module.exports = __webpack_public_path__ + "img/44-min.9197cafd.jpg";